import { DashboardNavComponent } from './dashboard-nav/dashboard-nav.component';
import { ListViewComponent } from './list-view/list-view.component';
import { LogoutComponent } from './logout/logout.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';

import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { ActivityComponent } from './activity/activity.component';
import { AccessErrorComponent } from './access-error/access-error.component';
import { ProblemNavComponent } from './problem-nav/problem-nav.component';
import { ProblemSideNavComponent } from './problem-sidenav/problem-sidenav.component';

import { AddcaseCategoriesComponent, buildMenu } from './addcase-categories/addcase-categories.component';
import { AddcaseContactComponent } from './addcase-contact/addcase-contact.component';
import { AddcaseProgressComponent } from './addcase-progress/addcase-progress.component';
import { AddcaseSearchComponent } from './addcase-search/addcase-search.component';
import { AssetComponent } from './asset/asset.component';
import { AddcaseDescriptionComponent } from './addcase-description/addcase-description.component';
import { AddcaseLocationComponent } from './addcase-location/addcase-location.component';
import { AddcaseConfirmationComponent } from './addcase-confirmation/addcase-confirmation.component';
import { ResultsViewComponent } from './results-view/results-view.component';
import { SearchFormComponent } from './search-form/search-form.component';
import { AttachmentsComponent } from './attachments/attachments.component';
import { LinkedCasesComponent } from './linked-cases/linked-cases.component';
import { AddAttachmentsComponent } from './add-attachments/add-attachments.component';

import { ContactsComponent } from './contacts/contacts.component';

import { AddcaseMenuComponent } from './addcase-menu/addcase-menu.component';

import { MapListComponent } from './map-list/map-list.component';

import { SavedSearchListComponent } from './saved-search-list/saved-search-list.component';

export const components: any[] = [
  DashboardNavComponent,
  ListViewComponent,
  LogoutComponent,
  NavMenuComponent,
  BreadcrumbComponent,
  ActivityComponent,
  AccessErrorComponent,
  ProblemNavComponent,
  ProblemSideNavComponent,
  AddcaseCategoriesComponent,
  AddcaseProgressComponent,
  AddcaseSearchComponent,
  AssetComponent,
  AddcaseDescriptionComponent,
  AddcaseLocationComponent,
  AddcaseContactComponent,
  AddcaseConfirmationComponent,
  ResultsViewComponent,
  SearchFormComponent,
  AttachmentsComponent,
  AddAttachmentsComponent,
  ContactsComponent,
  AddcaseMenuComponent,
  MapListComponent,
  SavedSearchListComponent,
  LinkedCasesComponent
];

export * from './dashboard-nav/dashboard-nav.component';
export * from './list-view/list-view.component';
export * from './logout/logout.component';
export * from './nav-menu/nav-menu.component';
export * from './breadcrumb/breadcrumb.component';
export * from './activity/activity.component';
export * from './access-error/access-error.component';
export * from './problem-nav/problem-nav.component';
export * from './problem-sidenav/problem-sidenav.component';
export * from './addcase-categories/addcase-categories.component';
export * from './addcase-contact/addcase-contact.component';
export * from './addcase-progress/addcase-progress.component';
export * from './addcase-search/addcase-search.component';
export * from './asset/asset.component';
export * from './addcase-description/addcase-description.component';
export * from './addcase-location/addcase-location.component';
export * from './addcase-confirmation/addcase-confirmation.component';
export * from './results-view/results-view.component';
export * from './search-form/search-form.component';
export * from './attachments/attachments.component';
export * from './add-attachments/add-attachments.component';
export * from './contacts/contacts.component';
export * from './addcase-menu/addcase-menu.component';
export * from './map-list/map-list.component';
export * from './saved-search-list/saved-search-list.component';
export * from './linked-cases/linked-cases.component';
